import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { BsPlus } from "react-icons/bs";
import "./style.css";
import { Backdrop } from "@material-ui/core";

const AddNewTest = (props) => {
  const [testName, setTestName] = useState("");
  const [testResultValue, setResultValue] = useState("");
  const [isCustomInput, setIsCustomInput] = useState(false);
  const [customInputValue, setCustomInputValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const possibleValues = [
    { label: "Non-Reactive", value: "Non-Reactive", key: "non-react" },
    { label: "Reactive", value: "Reactive", key: "react" },
    { label: "Not Detected", value: "Not Detected", key: "not-detected" },
    { label: "Detected", value: "Detected", key: "detected" },
  ];

  // Add 'Other' option for custom input
  possibleValues.push({ label: "Other", value: "other", key: "other" });

  const resultOptions = possibleValues.map((val) => (
    <option value={val.value} key={val.key}>
      {val.label}
    </option>
  ));

  const validateAndAddTest = () => {
    const resultValue = isCustomInput ? customInputValue : testResultValue;

    if (testName && testName.length && resultValue) {
      if (props.addNewTest) {
        props.addNewTest({
          testName,
          testValue: resultValue,
          newTest: true,
          testId: "",
        });
      }
      setTestName("");
      setResultValue("");
      setCustomInputValue("");
      setIsCustomInput(false);
      setErrorMessage("");
    } else {
      setErrorMessage("Enter all the required values");
    }
  };

  const handleResultValueChange = (value) => {
    if (value === "other") {
      setIsCustomInput(true);
      setCustomInputValue(""); // Clear previous custom input value
      setResultValue(""); // Clear the selected value
    } else {
      setIsCustomInput(false);
      setResultValue(value);
    }
  };

  return (
    <div className="new-test-form">
      <div className="message">{errorMessage}</div>
      <div className="flex-content">
        <div className="flex-form">
          <Form.Group>
            <Form.Control
              id="borderless"
              type="text"
              value={testName}
              onChange={(e) => setTestName(e.target.value)}
              placeholder="Test Name*"
            />
          </Form.Group>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "49%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="flex-form">
            <Form.Group>
              <Form.Control
                id="borderless"
                required
                value={isCustomInput ? "other" : testResultValue}
                as={"select"}
                onChange={(e) => handleResultValueChange(e.target.value)}
              >
                <option value="">Select result value*</option>
                {resultOptions}
              </Form.Control>
              {/* Show text input if "Other" is selected */}
              {isCustomInput && (
                <Form.Control
                  type="text"
                  placeholder="Enter your value"
                  value={customInputValue}
                  onChange={(e) => setCustomInputValue(e.target.value)}
                  style={{ marginTop: "10px" }}
                />
              )}
            </Form.Group>
          </div>
          <Button
            id="msg_reply"
            className="replyButton sendButton text-right"
            onClick={validateAndAddTest}
          >
            Add <BsPlus />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddNewTest;
